import request from '@/utils/request'

export function getRouters(params) {
  return request({
    url: '/power/setting/menu/getRouters',
    method: 'get',
    params,
  })
}
